import utils from './utils'
import wxAuth from './wxAuth'
import jsSdk from './jsSdk'

import cAppSdk from './jsBridge'
import store from '@/views/index/store'

import bAppSdk from './js-bridge-v2'
import Vue from 'vue';
import wx from 'weixin-js-sdk'
import browserJs from './browser'

// 音频
var audio = new Audio();
export default {
  environment: '', // 1 微信 2 C端app 3 B端app 0 不支持该环境
  async init () {
    let browser = utils.BrowserInfo()
    if (browser.isWeixin) {
      this.environment = 1
    } else if (navigator.userAgent.indexOf('communityapp') > -1) {
      this.environment = 2
    } else if (navigator.userAgent.indexOf('propertyapp') > -1) {
      this.environment = 3
    } else {
      this.environment = 0
    }
    return !!this.environment
  },
  isrRegister(){
    let flag = false;
    let userInfo = store.state.userInfo;

    if(!userInfo){
      return flag
    }

    sessionStorage.setItem('redirectUrl', window.location.pathname + window.location.search)

    switch (this.environment) {
      case 1:
        if (userInfo.flag) {
          flag = true
        }
        break;
      case 2:
        if (userInfo.token || Number(userInfo.loginState)) {
          flag = true
        }
        break;
      case 3:
        if (userInfo.token) {
          flag = true
        }
        break;
    }
    return flag
  },
  async getUserInfo (loginType) {
    let res = {}
    let result = {}
    if (this.environment === 1) {
      // 调用微信获取用户
      res = await wxAuth.getUserInfo(loginType)

    } else if (this.environment === 2 ) {
      // 调用c端app的获取用户
      res = await cAppSdk.getUserInfo()
    } else if (this.environment === 3) {
      // 调用B端app的获取用户
      res = await bAppSdk.getUserInfo()
    }

    return res
  },
  async chooseImage (count = 1, type = ['camera', 'album']) {
    if (this.environment == 1 || this.environment == 3) {
      if (type.indexOf('camera') == -1 && type.indexOf('album') == -1) {
        type = 'camera,album'
      } else if (type.indexOf('camera') > -1 && type.indexOf('album') == -1 ) {
        type = ['camera']
      } else {
        type = ['album']
      }
    }

    let res = {}
    let result = {}
    let arr = []
    if (this.environment === 1) {
      await jsSdk.init()
      // 调用微信获取用户
      res = await jsSdk.chooseImage(count, type)
      result = {
        fileKey: res.key ? res.key : '',
        filePath: res.url ? res.url : '',
      }
    } else if (this.environment === 2 ) {
      // 调用c端app的获取用户,C端字段：fileKey、filePath、fileType不用改
      arr  = await cAppSdk.chooseImage({ count, type })
      result = arr && arr.length ? arr[0] : {}
    } else if (this.environment === 3) {
      // 调用B端app的获取用户
      arr = await bAppSdk.chooseMedia({
        count,
        mediaType: 'image',
        sourceType: type,
      })
      res = arr && arr.length ? arr[0] : {}
      if (res.fileKey) {
        result = {
          fileKey: res.fileKey || '',
          filePath: res.fileUrl || '',
          fileType: res.fileType || ''
        }
      }
    } else {
      arr = await browserJs.uploadImage()
      res = arr && arr.length ? arr[0] : {}
      if (res.key) {
        result = {
          fileKey: res.key || '',
          filePath: res.url || '',
          fileType: res.fileType || ''
        }
      }
    }
    return result
  },
  async chooseImages (count = 1, type = ['camera', 'album']) {
    if (this.environment == 1 || this.environment == 3) {
      if (type.indexOf('camera') == -1 && type.indexOf('album') == -1) {
        type = 'camera,album'
      } else if (type.indexOf('camera') > -1 && type.indexOf('album') == -1 ) {
        type = ['camera']
      } else {
        type = ['album']
      }
    }
    let res = {}
    let result = []

    if (this.environment === 1) {
      await jsSdk.init()
      // 调用微信获取用户
      res = await jsSdk.chooseImage()
      if (res.length) {
        res.forEach((item) => {
          result.push({
            fileKey: item.key,
            filePath: item.url,
          })
        })
      }
    } else if (this.environment === 2 ) {
      // 调用c端app的获取用户
      result = await cAppSdk.chooseImage({ count, type })
    } else if (this.environment === 3) {
      // 调用B端app的获取用户
      res = await bAppSdk.chooseMedia({
        count,
        mediaType: 'image',
        sourceType: type,
      })
      if (res.length) {
        res.forEach((item) => {
          result.push({
            fileKey: item.fileKey,
            filePath: item.fileUrl,
          })
        })
      }
    }
    return result
  },
  async scanCode () {
    let res = {}
    let result = {}
    if (this.environment === 1) {
      await jsSdk.init()
      // 调用微信获取用户
      res = await jsSdk.scanCode()
    } else if (this.environment === 2 ) {
      // 调用c端app的获取用户
      res = await cAppSdk.scanCode()
    } else if (this.environment === 3) {
      // 调用B端app的获取用户
      res = await bAppSdk.scanCode()
    }
    return result
  },
  async getLocation () {
    let res = {}
    let result = {}
    if (this.environment === 1) {
      // 调用微信获取用户
      await jsSdk.init()
      result = await jsSdk.getLocation()
    } else if (this.environment === 2 ) {
      // 调用c端app的获取用户
      result = await cAppSdk.geolocation()
    } else if (this.environment === 3) {
      // 调用B端app的获取用户
      res = await bAppSdk.getLocation()
      result = {
        lat: res.latitude,
        lng: res.longitude
      }
    }
    return result
  },
  // 开始录音
  async startRecord () {
    let result = ''
    if (this.environment === 1) {
      // 录音前必须调用，否则无法获取录音授权
      await jsSdk.init()
      result = await jsSdk.startRecord();
    } else {
      result = await cAppSdk.startAudio()
    }
    return result
  },
  // 停止录音
  async stopRecord () {
    let result = []
    if (this.environment === 1) {
      await jsSdk.init()
      result = [await jsSdk.stopRecord()]
    } else if (this.environment === 2){
      result = await cAppSdk.stopAudio()
    }
    return result
  },
  // 开始播放音频
  async startPlayAudio (audioUrl, type) {
    if (!this.environment === 1) {
      return new Promise((resolve,rejected) => {
        audio.src = audioUrl
        if (type === "start") {
          audio.play();
          audio.addEventListener('ended', function () {
            resolve(1)
          }, false);
        }
        if (type === "stop") {
          audio.pause();
          resolve(1)
        }
      })
    } else {
      let res = await cAppSdk.startPlayAudio(audioUrl, type)
      console.log('tools===>res',res)
      return res
    }
  },
  // 预览图片
  async showImagePicker (index = 0, imagesUrl = []) {
    if (this.environment === 1) {
      await jsSdk.init()
      jsSdk.previewImage(index, imagesUrl)
    } else if (this.environment === 2){
      cAppSdk.showImagePicker(index, imagesUrl)
    }
  },
  async setShareData (shareData = {}, callback) {
    let res = {}
    let result = {}
    if (this.environment === 1) {
      await jsSdk.init()
      // 调用微信获取用户
      res = await jsSdk.setShareData(shareData, callback)

    } else if (this.environment === 2 ) {
      // 调用c端app的获取用户
      res = await cAppSdk.setShareData(shareData,callback)
    } else if (this.environment === 3) {
      // 调用B端app的获取用户
      res = await bAppSdk.setShareData(shareData)
    }
    return res
  },
  navigateToLogin() {
    if (this.environment === 1) {
      this.$router.push({
        name: 'login'
      })
    } else if (this.environment === 2){
      cAppSdk.navigateTo('login')
    }
  },
  navigateBack (actionStr) {
    if (this.environment === 1) {
      this.$router.back()
    } else if (this.environment === 2){
      cAppSdk.navigateBack(actionStr)
    }

  }
}
